import { translate } from '@jsverse/transloco';
export enum AssessmentStatus {
    NOT_STARTED = 'NOT_STARTED',
    PRE_ASSESSMENT = 'PRE_ASSESSMENT',
    IN_PROGRESS = 'IN_PROGRESS',
    PAUSED = 'PAUSED',
    DELAYED = 'DELAYED',
    SUBMITTED_TO_QA = 'SUBMITTED_TO_QA',
    IN_QA = 'IN_QA',
    RETURN_TO_ASSESSOR = 'RETURN_TO_ASSESSOR',
    READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
}

export class AssessmentStatusHelper {
    static getAssessmentStatusLocale(status: AssessmentStatus): string {
        switch (status) {
            case AssessmentStatus.NOT_STARTED:
                return translate('CORE.ASSESSMENT_STATUS.NOT_STARTED');
            case AssessmentStatus.PRE_ASSESSMENT:
                return translate('CORE.ASSESSMENT_STATUS.PRE_ASSESSMENT');
            case AssessmentStatus.IN_PROGRESS:
                return translate('CORE.ASSESSMENT_STATUS.IN_PROGRESS');
            case AssessmentStatus.IN_QA:
                return translate('CORE.ASSESSMENT_STATUS.IN_QA');
            case AssessmentStatus.PAUSED:
                return translate('CORE.ASSESSMENT_STATUS.PAUSED');
            case AssessmentStatus.DELAYED:
                return translate('CORE.ASSESSMENT_STATUS.DELAYED');
            case AssessmentStatus.SUBMITTED_TO_QA:
                return translate('CORE.ASSESSMENT_STATUS.SUBMITTED_TO_QA');
            case AssessmentStatus.RETURN_TO_ASSESSOR:
                return translate('CORE.ASSESSMENT_STATUS.RETURN_TO_ASSESSOR');
            case AssessmentStatus.READY_FOR_DELIVERY:
                return translate('CORE.ASSESSMENT_STATUS.READY_FOR_DELIVERY');
            case AssessmentStatus.CANCELED:
                return translate('CORE.ASSESSMENT_STATUS.CANCELED');
            case AssessmentStatus.COMPLETED:
                return translate('CORE.ASSESSMENT_STATUS.COMPLETED');
            default:
                return status;
        }
    }

    /**
     * @description
     * Returns an array of all the statuses except Canceled and Completed
     */
    static getDefaultAssessmentStatuses(): AssessmentStatus[] {
        return [
            AssessmentStatus.NOT_STARTED,
            AssessmentStatus.PRE_ASSESSMENT,
            AssessmentStatus.IN_PROGRESS,
            AssessmentStatus.PAUSED,
            AssessmentStatus.DELAYED,
            AssessmentStatus.SUBMITTED_TO_QA,
            AssessmentStatus.IN_QA,
            AssessmentStatus.RETURN_TO_ASSESSOR,
            AssessmentStatus.READY_FOR_DELIVERY,
        ];
    }
}
